export default __webpack_public_path__ + "static/media/06_photo.895837b4.jpeg";